import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { JustifyContentProps } from 'styled-system';
import { justifyContent, space } from 'styled-system';

import CtaButtonWithDrawer from 'common/components/Voucher/CtaButtonWithDrawer';
import type { SpaceProps } from 'common/theme/system-types';
import type { BannerProps } from '../types';

type BannerCtaButtonProps = {
  textColor?: BannerProps['textColor'];
  isMultiVoucher?: BannerProps['isMultiVoucher'];
  ctaButtonLabel?: BannerProps['ctaButtonLabel'];
  ctaButtonAriaLabel?: BannerProps['ctaButtonAriaLabel'];
  ctaDisclaimerContent?: BannerProps['ctaDisclaimerContent'];
};

const InnerBannerCtaButton = styled(CtaButtonWithDrawer)<JustifyContentProps & SpaceProps>`
  & {
    ${space};
    ${justifyContent};
  }

  > p {
    margin-right: 4px;
  }
`;

const innerBannerCtaButtonStyles: Partial<ComponentProps<typeof InnerBannerCtaButton>> = {
  pl: 'sp_8',
  py: 'sp_4',
  justifyContent: 'flex-start',
};

const BannerCtaButton = ({
  textColor,
  isMultiVoucher,
  ctaButtonLabel,
  ctaButtonAriaLabel,
  ctaDisclaimerContent,
}: BannerCtaButtonProps) => {
  if (!ctaButtonLabel || !ctaDisclaimerContent || !isMultiVoucher) return null;

  return (
    <InnerBannerCtaButton
      {...innerBannerCtaButtonStyles}
      ctaLabel={ctaButtonLabel}
      ctaColor={textColor ?? 'sys.neutral.text.default'}
      ctaDisclaimerText={ctaDisclaimerContent}
      {...(ctaButtonAriaLabel && { ctaAriaLabel: ctaButtonAriaLabel })}
    />
  );
};

export default BannerCtaButton;
